import { useCallback, useMemo } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { useConfigureUpcomingApplicationCycle } from 'store/feature-toggle/hooks'

import { fetchCurrentAppCycle, selectApplicationCycle } from '.'

export const useAppCycle = () => useSelector(selectApplicationCycle)
export const useRoundConfigurationAppCycle = () => {
  const currentAppCycle = useAppCycle()
  const isFeatureEnabled = useConfigureUpcomingApplicationCycle()
  return useMemo(() => {
    if (!isFeatureEnabled) {
      return currentAppCycle
    }
    return currentAppCycle + 1
  }, [isFeatureEnabled, currentAppCycle])
}
export const useFetchCurrentAppCycle = () => {
  const dispatch = useDispatch()
  return useCallback(() => dispatch(fetchCurrentAppCycle()), [dispatch])
}
